import React, { useDeferredValue } from "react";
import cx from "classnames";
import { colors, spacings } from "@ui/Theme";
import { css } from "@linaria/core";
import { useDashboardListingFolding } from "../hook/useDashboardListingFolding";

// eslint-disable-next-line @typescript-eslint/no-unused-expressions
css`
  :global() {
    :root {
      --dashboard-editor-width: 320px;
      --dashboard-listing-width: 275px;
      --section-column-transition-duration: 350ms;
      --section-column-transition-ease: cubic-bezier(0.4, 0, 0.2, 1);
    }
  }
`;

/**
 * @description View's general grid layout.
 */
export const dashboardSection = css`
  --left-column-width: var(--dashboard-listing-width, 275px);
  --right-column-width: ${spacings.l};

  background-color: ${colors.titanium50};
  min-height: calc(100vh - var(--primary-header-height));
  display: grid;
  grid-template-columns: var(--left-column-width) 1fr var(--right-column-width);
  grid-auto-rows: max-content;
  transition: grid-template-columns var(--section-column-transition-duration)
    var(--section-column-transition-ease);
  color: ${colors.carbon900};

  &.leftColumnFolded {
    --left-column-width: ${spacings.xxl};
  }

  &.rightColumnExpanded {
    --right-column-width: var(--dashboard-editor-width, 500px);
    column-gap: ${spacings.l};
  }
`;

export const SectionContainer = ({
  editable = false,
  children,
  className,
}: React.PropsWithChildren<{ editable?: boolean; className?: string }>) => {
  const [isListingFolded] = useDashboardListingFolding({});
  const deferredEditable = useDeferredValue(editable);
  return (
    <section
      className={cx(
        dashboardSection,
        {
          leftColumnFolded: isListingFolded,
          rightColumnExpanded: deferredEditable,
        },
        className,
      )}
    >
      {children}
    </section>
  );
};
